import {Component, ViewChild, ChangeDetectorRef} from '@angular/core';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {IonicModule, Platform} from '@ionic/angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [StatusBar],
})
export class AppComponent {

    /**
     * Constructor
     */
    constructor(
        private _statusBar: StatusBar,
        private _platform: Platform,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        // set status color
        this._statusBar.styleDefault();

        // set status bar to white
        this._statusBar.backgroundColorByHexString('#ffffff');
    }
}
